/**
 * Shared sample data for CSV template downloads.
 * Used by import users, bulk delete, and bulk update templates.
 *
 * Keys cover all column names used across templates, including "(required)" variants.
 * All templates use unified short column names (Phone, Email, Group, Team).
 */
export const CSV_TEMPLATE_SAMPLE_VALUES: Record<string, string> = {
    // Identifiers (with and without required suffix)
    'Phone': '+19998887777',
    'Phone (required)': '+19998887777',
    'Email': 'mike@example.com',
    'Email (required)': 'mike@example.com',
    'Employee ID': '123456',
    'Employee ID (required)': '123456',

    // Name fields
    'First Name': 'Mike',
    'First Name (required)': 'Mike',
    'Last Name': 'Ross',
    'Last Name (required)': 'Ross',
    'Full Name': 'Mike Ross',

    // Organization
    'Group': 'Northeast Region',
    'Team': 'Behavioral Health',
    'Job Title': 'Field Nurse',

    // Tags
    'Tag One': 'Full Time',
    'Tag Two': 'Day Shift',
    'Tag Three': 'New Hire',
};
